module.exports = __webpack_public_path__ + "media/images/front/home/taronja-4051790839bdbc8042a3b34eaa53ffec.png";